module.exports = function() {
  return new Worker(__webpack_public_path__ + "19b09b75ac082beeae4c.worker.js");
};